import { render, staticRenderFns } from "./TipoApreensaoSelect.vue?vue&type=template&id=5941234a"
import script from "./TipoApreensaoSelect.vue?vue&type=script&lang=js"
export * from "./TipoApreensaoSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports